import { CommercialSaleComponent } from './commercial-sale/commercial-sale.component';

export const COMMERCIAL_MAP_ROUTES = [
    {
        path: 'market',
        component: CommercialSaleComponent,
    },
];
